import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Navigation, BookOpen } from "react-feather";
import PageShell from "../../components/premium/layout/PageShell";
import PageHero from "../../components/premium/layout/PageHero";
import rudraImg from "../../assets/images/rudra-ride-logo.png";
import eduImg from "../../assets/images/edu-pravahaa-logo.png";

const products = [
  {
    title: "Rudra Ride",
    tag: "Smart Mobility",
    desc: "Instant cab booking, live GPS tracking, secure UPI/card payments, and 24/7 availability across the city.",
    image: rudraImg,
    link: "/rudra-rides",
    icon: Navigation,
    features: ["Live Tracking", "Secure Wallet", "24/7 Rides", "Referral Rewards"],
  },
  {
    title: "Edu Pravahaa",
    tag: "Digital Education",
    desc: "Industry-aligned courses, LMS platform, guaranteed internships, and placement assistance for career-ready graduates.",
    image: eduImg,
    link: "/edupravahaa",
    icon: BookOpen,
    features: ["LMS Access", "Live Classes", "Internship", "Certificates"],
  },
];

export default function ProductsPage() {
  return (
    <PageShell>
      <PageHero
        badge="Our Products"
        title="Innovation That"
        highlight="Moves Forward"
        subtitle="Two flagship platforms transforming mobility and education across India."
      />

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {products.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className={`grid lg:grid-cols-2 gap-8 items-center premium-glass premium-glass-glow rounded-3xl p-8 lg:p-12 ${
                i % 2 === 1 ? "lg:flex-row-reverse" : ""
              }`}
            >
              <div className={i % 2 === 1 ? "lg:order-2" : ""}>
                <span className="premium-badge mb-4">{p.tag}</span>
                <h2 className="text-3xl lg:text-4xl font-bold text-white flex items-center gap-3">
                  <p.icon className="text-[#2563EB]" size={32} />
                  {p.title}
                </h2>
                <p className="mt-4 text-white/65 text-lg leading-relaxed">{p.desc}</p>
                <ul className="mt-6 flex flex-wrap gap-2">
                  {p.features.map((f) => (
                    <li key={f} className="px-3 py-1.5 rounded-lg bg-white/5 text-sm text-white/80 border border-white/10">
                      {f}
                    </li>
                  ))}
                </ul>
                <Link
                  to={p.link}
                  className="mt-8 inline-flex items-center gap-2 text-[#F5C044] font-semibold hover:gap-3 transition-all"
                >
                  Explore {p.title} <ArrowRight size={18} />
                </Link>
              </div>
              <div className={`flex justify-center ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                <div className="relative p-8 rounded-2xl bg-white border border-white/20 shadow-lg">
                  <img src={p.image} alt={p.title} className="max-h-44 w-full object-contain" />
                  <div className="absolute -inset-4 bg-[#2563EB]/10 blur-2xl rounded-full -z-10" />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </PageShell>
  );
}
